import React from 'react';
import styled from 'styled-components';

interface Props {
  isOpen: boolean,
  size?: number,
}

const ToggleButton:React.FC<Props> = ({
  isOpen,
  size = 20,
}) => {
  return (
    <ToggleButtonOuter
      className={isOpen ? 'open' : ''}
      size={size}
    >
      <Bar />
      <Bar />
    </ToggleButtonOuter>
  );
};
export default ToggleButton;

const ToggleButtonOuter = styled.div<{ size: number }>`
  position: relative;
  top: ${(p) => p.size / 2}px;
  width: ${(p) => p.size}px;
  height: ${(p) => p.size}px;
  flex: 0 0 ${(p) => p.size}px;
`;
const Bar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: ${(p) => p.theme.palette.primary};
  transform: rotate(-90deg);
  &:nth-of-type(2) { transform: rotate(0deg); }
  transition: transform 0.3s;
  transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
  ${ToggleButtonOuter}.open & {
    transform: rotate(45deg);
    &:nth-of-type(2) { transform: rotate(-225deg); }
  }
`;
